import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import UserPieChart from './Highcharts_Pie'; 
import TotalHits from './TotalHits'
import TotalHUMIDUsers from './TotalHUMIDUsers';
import TotalDownloads from './TotalDownloads';
import axios from "axios";
import domain from "./domain";
import CylinderChart from './CylinderChart';
import { CallReceived } from '@material-ui/icons';



class UserStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = 
    {
      series_barchart:[],
      categories_barchart:[],
      series:[],
      categories:[],
      totalhit:null,
      totaldownloads:null,
      humidhits:null,
      themenames:[
       
        { theme: 'Irrigation', abbreviation: 'Irrigation' },
        { theme: 'VIC', abbreviation: 'Hydrological Modeling' },
        { theme: 'Drought', abbreviation: 'Hydrological Drought' },
        { theme: 'ET', abbreviation: 'Evapotranspiration' },
        { theme: 'SNOW', abbreviation: 'SnowMelt Runoff' },
        
      ],
      };
    
      
  }


 componentDidMount()
{
  let downloads=null,
  glof_downloads=null,
  totaldown=null,
  categories=[],
  series=[],
  years=[],
  yearlycount=[],
  humiduser="#",
  totalcount=null;
  axios.get(`${domain.DBServer}/get-humid-user`).then((result) => {
    if (result) {
      
      this.setState({
        humidhits:result.data[0].user_count
      });
      console.log(this.state.humidhits,result.data[0],"kkkhumid")

    }
  });
  axios.get(`${domain.DBServer}/get-total-user-hits2023`).then((result) => {
    if (result) {
      
      this.setState({
        totalhit:result.data[0].count
      });
      console.log("total hits",this.state.totalhit,result.data.count,result.data)

    }
  });
  axios.get(`${domain.DBServer}/get-total-download2023`).then((result) => {
    if (result) {
      downloads=result.data.data1[0].count
      glof_downloads=result.data.data2[0].count
      totaldown=Number(downloads)+Number(glof_downloads)
      this.setState({
        totaldownloads:totaldown
      })
console.log("total downloads",this.state.totaldownloads)
    }
  })

  
axios.get(`${domain.DBServer}/get-categorywise-download2023`).then((result) => {
    if (result) {
      console.log("sereeeeeeeeeeeeies cate",result.data)
      result.data.data1.map((result) => {
        series.push(Number(result.count));
        return true;
      });
     
        result.data.data1.map((result) => {
          const name = this.state.themenames.find(item => item.theme.toLowerCase() === (result.theme).toLowerCase());
          console.log(name.abbreviation,"nameeeeeeeeee")
          
          categories.push(name.abbreviation);
          return true;
        });
       
        this.setState({
          series:series,
          categories:categories
        })
    }
    
  })
  

 axios.get(`${domain.DBServer}/get-yearly-downloads2023`).then((result) => {
    if (result) {
      console.log("resssssssssssssssssssssss",result,result.data[0].year,result.data[0].count)
      result.data.map((result) => {
        years.push(result.year);
      });
      result.data.map((result) => {
        yearlycount.push(Number(result.count));
      });
    this.setState({

      series_barchart:yearlycount,
      categories_barchart:years
    })
    }
  })
}

    render() 

  {
    console.log("UUUUUUUUUUU",this.state.series_barchart,this.state.categories_barchart,this.state.series,this.state.categories,this.state.totaldownloads,this.state.totalhits)

    return (
     < Container >
      <Row>
        <Col>
        <Container fluid className="big-title"> 
      <h2 className="blue-text1"> User Stats <span className="red-text1"> & </span>Downloads</h2>

          </Container>
        
        </Col>
      </Row>
    
        <Row >
          <Col md={6} lg={6} className='text-center' >
            
          <p className="bulletinrelease">Yearly Downloads</p>
            {/* Content for the left column */}
            <CylinderChart
            series={this.state.series_barchart}
            categories={this.state.categories_barchart}
            />
          </Col>
          <Col md={6} lg={6}className='text-center'>
          <p className="bulletinrelease">Category-wise Downloads</p>
            {/* Content for the right column */}
            <UserPieChart className="userpiechart"
            series={this.state.series}
            categories={this.state.categories}/>
          </Col>
          
        </Row>
        <Row >
          <Col md={1} lg={1}  sm={3} xs={2}/>
          <Col className='text-center' md={3} lg={3}  sm={9} xs={10}>
            {/* Content for the first small column */}
            <TotalDownloads value={this.state.totaldownloads}
            />
          </Col>
          <Col md={1} lg={1}  sm={3} xs={2}/>

          <Col className='text-center' md={3} lg={3} sm={9} xs={10}>
            {/* Content for the second small column */}
            <TotalHits 
            value={this.state.totalhit}/>
          </Col>
          <Col md={1} lg={1}  sm={3} xs={2}/>

          <Col className='text-center' md={3} lg={3} sm={9} xs={10}>
            {/* Content for the third small column */}
            <TotalHUMIDUsers 
            value={this.state.humidhits}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default UserStatistics;
